/**
 * ADR-20261018-1skz: the shared guard the HTTP OnFilePort, RenewalDataPort
 * and WorkingCopyPort implementations use so an unauthenticated route
 * triggers no network request at all. Not used by `renewal-summary-client.ts`
 * (out of this ADR's named scope) or by the write side of WorkingCopyPort's
 * save latch (`working-copy-client.ts`) — this is a read-time concern for
 * the three ports this ADR names.
 *
 * `getSessionToken() !== null` is checked synchronously at call time. If a
 * token is already held, `run` is invoked immediately — no added delay, no
 * extra tick. If no token is held, this function makes NO call to `run` at
 * all (so the underlying `authenticatedFetch` never fires); it subscribes
 * to `subscribeTokenChange` and invokes `run` only once a token appears,
 * unsubscribing immediately after. Every route gated by `requireSession`
 * (App.tsx) only mounts once a token exists, so in practice this deferral
 * matters only for a port constructed — but not yet read from — before
 * sign-in completes (e.g. a composition root that builds every port up
 * front, per ADR-20261015-bzyr).
 */
import { getSessionToken, subscribeTokenChange } from "../../portal-auth/token";

export function whenSessionTokenHeld<T>(run: () => Promise<T>): Promise<T> {
  if (getSessionToken() !== null) {
    return run();
  }
  return new Promise<T>((resolve, reject) => {
    const unsubscribe = subscribeTokenChange(() => {
      if (getSessionToken() === null) {
        return;
      }
      unsubscribe();
      run().then(resolve, reject);
    });
  });
}
